<template>

    <div :class="'player-' + youtube_id" data-plyr-provider="youtube" :data-plyr-embed-id="youtube_id"></div>

</template>

<script>

    import plyr from 'plyr'

	export default {
		name: 'YouTubePlayer',
		data () {
			return {
                players: null,
            }
        },
        props: [
            'youtube_id',
        ],
        // watch: {
        //     streamId: function() {
        //         if(this.player !== null) {
        //             var _this = this
        //             this.player.configure({
        //                 source: "https://edge-media.livestormchasing.com/hls/" + _this.streamId + "/index.m3u8",
        //                 autoPlay: true,
        //             });
        //         }
        //     }
        // },
		mounted() {
            this.players = plyr.setup('.player-' + this.youtube_id);
		},
		methods: {
            initVid() {
                this.players = plyr.setup('.player-' + this.youtube_id);
            }
        },
        destroyed() {
            this.players[0].destroy();
        },

	}
</script>

<style>
	#videoHolder {
		width: 100%;
		height: 100%;
	}

    .video {
        width: 100%;
        height: 100%;
    }
</style>
